module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "logical-statement-view"
    }
  }, [(typeof _vm.list.conj !== 'undefined') ? [_c('div', {
    staticClass: "conjuction-box clearfix"
  }, [_c('span', {
    staticClass: "desc-text"
  }, [_vm._v(_vm._s(_vm.list.descConj) + " ")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-close close-button",
    on: {
      "click": function($event) {
        _vm.deleteList(_vm.index)
      }
    }
  }), _vm._v(" "), (_vm.linkDisp) ? [(_vm.totalLists >= 2) ? _c('i', {
    staticClass: "fa fa-unlink unlink-button",
    attrs: {
      "title": "click for link statement"
    },
    on: {
      "click": function($event) {
        _vm.setLinkDisp(_vm.index)
      }
    }
  }) : _c('i', {
    staticClass: "fa fa-unlink unlink-button -disable",
    attrs: {
      "title": "required minimum 2 statements for linking"
    }
  })] : [(_vm.totalLists >= 2) ? _c('i', {
    staticClass: "fa fa-link link-button color-skin",
    attrs: {
      "title": "click for unlink statement"
    },
    on: {
      "click": function($event) {
        _vm.setUnlinkDisp(_vm.index)
      }
    }
  }) : _c('i', {
    staticClass: "fa fa-link link-button -disable color-skin",
    attrs: {
      "title": "required minimum 2 statements for unlinking"
    }
  })], _vm._v(" "), _c('i', {
    staticClass: "fa fa-pencil ungroup-button",
    attrs: {
      "title": "click for edit statement"
    },
    on: {
      "click": function($event) {
        _vm.editList(_vm.index)
      }
    }
  })], 2)] : _vm._e(), _vm._v(" "), (typeof _vm.list.conj === 'undefined') ? [_c('div', {
    staticClass: "text-box clearfix"
  }, [_c('span', {
    staticClass: "desc-text"
  }, [_vm._v(_vm._s(_vm.list.descStmt))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-close close-button",
    attrs: {
      "title": "click for cancel statement"
    },
    on: {
      "click": function($event) {
        _vm.deleteList(_vm.index)
      }
    }
  }), _vm._v(" "), (_vm.linkDisp) ? [(_vm.totalLists >= 2) ? _c('i', {
    staticClass: "fa fa-unlink unlink-button",
    attrs: {
      "title": "click for link statement"
    },
    on: {
      "click": function($event) {
        _vm.setLinkDisp(_vm.index)
      }
    }
  }) : _c('i', {
    staticClass: "fa fa-unlink unlink-button -disable",
    attrs: {
      "title": "required minimum 2 statements for linking"
    }
  })] : [(_vm.totalLists >= 2) ? _c('i', {
    staticClass: "fa fa-link link-button color-skin",
    attrs: {
      "title": "click for unlink statement"
    },
    on: {
      "click": function($event) {
        _vm.setUnlinkDisp(_vm.index)
      }
    }
  }) : _c('i', {
    staticClass: "fa fa-link link-button -disable color-skin",
    attrs: {
      "title": "required minimum 2 statements for unlinking"
    }
  })], _vm._v(" "), (typeof _vm.list.statement !== 'undefined') ? _c('i', {
    staticClass: "fa fa-object-ungroup ungroup-button",
    attrs: {
      "title": "click for ungroup statement"
    },
    on: {
      "click": function($event) {
        _vm.ungroupList(_vm.index)
      }
    }
  }) : _vm._e(), _vm._v(" "), (typeof _vm.list.statement === 'undefined') ? _c('i', {
    staticClass: "fa fa-pencil ungroup-button",
    attrs: {
      "title": "click for edit statement"
    },
    on: {
      "click": function($event) {
        _vm.editList(_vm.index)
      }
    }
  }) : _vm._e()], 2)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e0607216!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrmsLogicalStatement/listView.vue
// module id = 3998
// module chunks = 1